import { getArrayApiClient } from 'adapter/out/client/apiClient';
import { Automation } from 'domain/entity/automation';

const readAutomationsApiClient = getArrayApiClient(() => `dashboards/automations`, Automation);

export default readAutomationsApiClient;
